// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker-cssmodules.css';

import ContainerModal from 'wdna-components/lib/modals/generics/ContainerModal';

import { WasteInfoDO } from '../../requests';

import './assets/RecalibrateModal.css';

/**
 * Generate the TZ offset string of date
 *
 * @param date to calculate the tz offset
 * @returns string with the offset info
 */
function getTimeZoneOffset(date?: Date): string {
  let result: string = '';
  if (date) {
    const tzOffset: { hours: number; minutes: number; } = {
      hours: Math.trunc(-date.getTimezoneOffset() / 60),
      minutes: -date.getTimezoneOffset() % 60,
    };
    result = `UTC ${tzOffset.hours < 0 ? '-' : '+'}${String(tzOffset.hours).padStart(2, '0')}:${String(tzOffset.minutes).padStart(2, '0')}`;
  }

  return result;
}

interface Props {
  show?: boolean;
  title?: string;
  newRecal?: boolean;
  info?: Partial<WasteInfoDO>;
  onSave: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onCancel: (e?: React.MouseEvent<HTMLButtonElement>) => void;
  onChange: (e: React.ChangeEvent<HTMLInputElement> | Date | null) => void;
}

/**
 * Function to generate a form component
 *
 * @param props properties of the component
 * @returns jsx element with the form
 */
export default function RecalibrateModal(props: Props): JSX.Element {
  const { newRecal, info, show, title, onSave, onCancel, onChange } = props;
  const timezoneString: string = getTimeZoneOffset(info?.date);

  return (
    <ContainerModal
      fullScreenButton={false}
      show={show}
      title={title}
      modalClass="modal-small selector-modal"
      onClose={onCancel}
      footerButtons={[
        {
          text: 'Close',
          className: 'btn btn-primary',
          onClick: onCancel,
        },
        {
          text: 'Save',
          className: 'btn btn-primary',
          onClick: onSave,
        },
      ]}
    >
      <fieldset style={{ padding: '10px 30%' }}>
        <div className="row">
          <div className="col-6">
            <label className="label">
              <b>Date</b>
            </label>
            &nbsp;&nbsp;
            <i className="fa fa-calendar">
              <DatePicker
                name="info.date"
                selected={info?.date}
                onChange={onChange}
                className="input-mandatory"
                showTimeSelect
                timeFormat="HH:mm:ss"
                timeIntervals={15}
                dateFormat={`yyyy-MM-dd HH:mm:ss '${timezoneString}'`}
                timeCaption="time"
                todayButton="TODAY"
                disabled={!newRecal}
                required
              />
            </i>
          </div>
        </div>
        <br />
        <div className="row">
          <div className="col-6">
            <label className="label">
              <b>Ratio Wheel-1</b>
            </label>
            &nbsp;
            <input
              id="info.ratio1"
              name="info.ratio1"
              type="number"
              value={info?.ratio1 || 0}
              onChange={onChange}
              data-ctype="number"
              className="input-mandatory"
              required
            />
          </div>
        </div>
        <br />
        <div className="row">
          <div className="col-6">
            <label className="label">
              <b>Ratio Wheel-2</b>
            </label>
            &nbsp;
            <input
              id="info.ratio2"
              name="info.ratio2"
              type="number"
              value={info?.ratio2 || 0}
              onChange={onChange}
              data-ctype="number"
              className="input-mandatory"
              required
            />
          </div>
        </div>
        <br />
        <div className="row">
          <div className="col-6">
            <label className="label">
              <b>Ratio Wheel-3</b>
            </label>
            &nbsp;
            <input
              id="info.ratio3"
              name="info.ratio3"
              type="number"
              value={info?.ratio3 || 0}
              onChange={onChange}
              data-ctype="number"
              className="input-mandatory"
              required
            />
          </div>
        </div>
        <br />
        <div className="row">
          <div className="col-6">
            <label className="label">
              <b>Ratio Wheel-4</b>
            </label>
            &nbsp;
            <input
              id="info.ratio4"
              name="info.ratio4"
              type="number"
              value={info?.ratio4 || 0}
              onChange={onChange}
              data-ctype="number"
              className="input-mandatory"
              required
            />
          </div>
        </div>
      </fieldset>
    </ContainerModal>
  );
}

RecalibrateModal.defaultProps = {
  show: false,
  newRecal: false,
  info: {},
  title: '',
};
